const Images = {
    //skill images
    html: require('./Skills/html.png').default,
    css: require('./Skills/css3.png').default,
    javascript: require('./Skills/javascript.png').default,
    ejs: require('./Skills/ejs.png').default,
    react: require('./Skills/react.png').default,
    node: require('./Skills/node-js.png').default,
    express: require('./Skills/express.png').default,
    python: require('./Skills/python.png').default,
    mongodb: require('./Skills/mongodb.png').default,
    postgresql: require('./Skills/postgresql.png').default,
    bootstrap: require('./Skills/bootstrap.png').default,
    sass: require('./Skills/sass.png').default,
    
    //source images
    myphoto: require('./Sources/my_photo.jpeg').default,
    elogo: require('./Sources/email.png').default,
    mylogo: require('./Sources/portfolio_logo.png').default,
    git: require('./Skills/git.png').default,
    github: require('./Sources/github.png').default,
    linkedin: require('./Sources/linkedin.png').default
}

export default Images